export default [
  {
    path: 'credito/welcome',
    name: 'credito-listar',
    component: () => import('../views/CreditoWelcomeView.vue'),
    meta: {
      title: 'Crédito',
    },
  },
  {
    path: 'credito/add',
    name: 'credito-cadastrar',
    component: () => import('../views/CreditoFormView.vue'),
    meta: {
      title: 'Cadastrar crédito',
    },
  },
  {
    path: 'credito/:id',
    name: 'credito-editar',
    component: () => import('../views/CreditoFormView.vue'),
    meta: {
      title: 'Editar crédito',
    },
  },
];
